/** Filter + paginate approval rows (pure helpers — DRY). */

export function filterApprovalProducts(rows, { tab, search, statusMenu, category }) {
  const q = search.trim().toLowerCase();
  let list = rows;

  if (tab === "pending") {
    list = list.filter((r) => r.approvalStatus === "pending");
  } else if (tab === "approved") {
    list = list.filter((r) => r.approvalStatus === "approved");
  } else if (tab === "rejected") {
    list = list.filter((r) => r.approvalStatus === "rejected");
  } else if (tab === "all" && statusMenu) {
    list = list.filter((r) => r.approvalStatus === statusMenu);
  }

  if (category && category !== "all") {
    list = list.filter((r) => r.categorySlug === category);
  }

  if (q) {
    list = list.filter(
      (r) =>
        r.name.toLowerCase().includes(q) ||
        r.sku.toLowerCase().includes(q)
    );
  }

  return list;
}

export function paginateSlice(items, page, pageSize) {
  const safePage = Math.max(1, page);
  const start = (safePage - 1) * pageSize;
  return items.slice(start, start + pageSize);
}

export function totalPagesFor(itemsLength, pageSize) {
  return Math.max(1, Math.ceil(itemsLength / pageSize));
}
